import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { setCurrentTrack } from '../Redux/currentTrack';
// import { setPlayState } from '../Redux/currentPlayState';
import { setDeviceId } from '../Redux/deviceId';


import play from '../assets/playPlayer.svg'
import pause from '../assets/pausePlayer.svg'
import back from '../assets/backwards.svg'
import forward from '../assets/forwards.svg'

function WebPlayback() {
    const { token } = useSelector((state) => state.accessToken);
    const currentTrack = useSelector((state) => state.currentTrack);
    const playState = useSelector((state) => state.currentPlayState);
    const dispatch = useDispatch();

    const [player, setPlayer] = useState(undefined);
    const [current_track, setTrack] = useState(currentTrack);
    const [localPlayState, setLocalPlayState] = useState(playState);

    useEffect(() => {
        if (player && currentTrack && playState) {
            player.resume();
        }
    }, [])

    // Player configuration
    useEffect(() => {
        if (!token) return;
        const script = document.createElement("script");
        script.src = "https://sdk.scdn.co/spotify-player.js";
        script.async = true;

        document.body.appendChild(script);

        window.onSpotifyWebPlaybackSDKReady = () => {
        const player = new window.Spotify.Player({
            name: "Snobify",
            getOAuthToken: (cb) => {
            cb(token);
            },
            volume: 0.5,
        });

        setPlayer(player);

        player.addListener("ready", ({ device_id }) => {
            dispatch(setDeviceId(device_id));
            console.log("Ready with Device ID", device_id);
        });

        player.addListener("not_ready", ({ device_id }) => {
            console.log("Device ID has gone offline", device_id);
        });

        player.connect();

        player.addListener("player_state_changed", (state) => {
            if (!state) {
            return;
            }

            setTrack(state.track_window.current_track);
        });
        };
    }, [token]);

    return (
        <>
        <div className="player">
            {current_track.name ? (
            <div className="playing-track">
                <img
                src={current_track.album.images[0].url}
                className="now-playing-cover"
                alt="artwork"
                />
                <div className="playing-track-info">
                <div className="now-playing__name">{current_track.name}</div>
                <div className="now-playing__artist">
                    {current_track.artists[0].name}
                </div>
                </div>
            </div>
            ) : null}
            <div className="media-controls">
            <img
                className="btn-spotify skip"
                src={back}
                alt="back"
                onClick={() => player.previousTrack()}
            />
            <img
                className="btn-spotify play"
                src={playState ? play : pause}
                alt="play"
                onClick={() => {
                    player.togglePlay()
                    setLocalPlayState(!localPlayState)}}
            />
            <img
                className="btn-spotify skip"
                src={forward}
                alt="forward"
                onClick={() => player.nextTrack()}
            />
            </div>
        </div>
        </>
    );
}

export default WebPlayback;